var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHighfive = function SvgHighfive(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.602 5.643c.198-.72.945-1.15 1.667-.961.723.188 1.149.925.95 1.645l-1.84 6.694.254.44L20.3 12.5a1.402 1.402 0 0 1 1.918.5 1.397 1.397 0 0 1-.3 1.75l-1.518 1.327L15.46 20m2.14-14.357.479-1.738a1.331 1.331 0 0 0-.95-1.646 1.374 1.374 0 0 0-1.668.963l-1.43 5.197m3.57-2.776-1.191 4.33M9.268 5.333a1.374 1.374 0 0 1 1.668-.963 1.33 1.33 0 0 1 .95 1.645m0 0v.001m0-.001.479-1.737a1.374 1.374 0 0 1 1.667-.963 1.33 1.33 0 0 1 .95 1.646",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.251 8.933a1.374 1.374 0 0 0-1.81-.659 1.331 1.331 0 0 0-.65 1.786l3.287 6.927-2.295-.835a1.402 1.402 0 0 0-1.802.826 1.397 1.397 0 0 0 .599 1.67l4.432 2.68a6.56 6.56 0 0 0 6.122.36 6.361 6.361 0 0 0 3.106-8.532L13.404 7.18a1.374 1.374 0 0 0-1.81-.658 1.33 1.33 0 0 0-.65 1.786m1.74 3.668-2.513-5.297a1.374 1.374 0 0 0-1.81-.659 1.33 1.33 0 0 0-.65 1.786m2.513 5.297L6.938 6.176a1.374 1.374 0 0 0-1.81-.659 1.33 1.33 0 0 0-.65 1.786l3.286 6.927"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHighfive);
export default ForwardRef;